export default __webpack_public_path__ + "static/media/Instagram.bed6a289.svg";